

const _ = require('lodash');

function formatForCode(string) {
    return _.deburr(string).replace(/[^A-Za-z0-9]/g, '').toLowerCase();
}

module.exports = formatForCode;
